export const MSG_CASHIER_SUCCESS = "Order Placed Succefully!";
export const MSG_CASHIER_FAILED = "Order Placed Failed!";

export const MSG_VOUCHER_SUCCESS = "Voucher added successfully.!";
export const MSG_VOUCHER_FAILED = "Voucher added Failed!";
export const MSG_VOUCHER_NO_MATCH = "No voucher matches the entered code.!";
export const MSG_VOUCHER_NOT_AVAILABLE =
  "No vouchers available for the entered code.";

export const MSG_VOUCHER_ENTER = "Please enter a voucher code!";

export const MSG_INPUTS_FAILED = "Please fill all the required fields.";

export const LOGIN_SUCCESS = "Hi, Welcome Back!";
export const LOGIN_FAILED =
  "Login failed. Please check your credentials and try again.!";

export const ADD_TO_CART = "Please log in to add items to the cart.";

export const MSG_GROUPACCESS_SUCCESS = "Group access mapped successfully!";
export const MSG_GROUPACCESS_FAILED = "Group access mapped failed!";

export const MSG_KITCHEN_SUCCESS = "Order Ready!";
export const MSG_KITCHEN_FAILED = "Order Not Ready!";

export const MSG_REPORT_SUCCESS = "Report mapped successfully!";
export const MSG_REPORT_FAILED = "Report mapped failed!";

export const MSG_UPDATE_ACC_SUCCESS = "Update Account Successfully!";
export const MSG_UPDATE_ACC_FAILED =
  "Failed to update the account. Please try again";

// src/utils/DialogMessages.js

export const DIALOG_TITLES = {
  DELETE: "Confirm Delete",
  UPDATE: "Confirm Update",
};

export const DIALOG_MESSAGES = {
  DELETE: "Are you sure you want to delete this order?",
  UPDATE: "Are you sure you want to update this order?",
};
